<template>
  <v-navigation-drawer
    stateless
    :value="show"
    absolute
    clipped
    left
    :width="$vuetify.breakpoint.smAndUp ? 320 : '100%'"
    style="left: 60px;"
    class="pt-1"
  >
    <v-toolbar flat dense>
      <v-toolbar-title class="grey--text">
        <v-btn icon small @click="$emit('close')">
          <v-icon small color="grey" style="transform: rotate(180deg);">double_arrow</v-icon>
        </v-btn>
        Research
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <library-modal></library-modal>
        <v-menu :close-on-content-click="false">
          <template v-slot:activator="{ on: onMenu }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: onTip }">
                <v-btn icon v-on="{ ...onTip, ...onMenu }"><v-icon>library_add</v-icon></v-btn>
              </template>
              Add Research
            </v-tooltip>
          </template>
          <add-resource-widget @created=""></add-resource-widget>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-list>
      <v-list-item
        link
        @click="setSelectedPageId({ page: 'resources' })"
        :class="selectedPageId == 'resources' ? 'v-list-item--active' : ''"
      >
        <v-list-item-icon>
          <v-icon>view_comfy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>All Research</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-subheader>Research Categories</v-subheader>
      <category-list-item
        v-for="category in resourcesByCategory"
        :category="category"
        :key="category.id"
      ></category-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import CategoryListItem from './CategoryListItem';
import AddResourceWidget from '@/components/Resources/AddResourceWidget';
import LibraryModal from '@/views/Context/components/LibraryModal';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  components: { CategoryListItem, AddResourceWidget, LibraryModal },
  data() {
    return {};
  },
  props: ['show'],
  computed: {
    ...mapGetters('context', ['context', 'userCanEdit']),
    ...mapState('views/context', ['selectedPageId', 'highlightedItems']),
    ...mapGetters('resources', ['resourcesByCategory'])
  },
  mounted() {
    //  Handle up and down keys when nothing is focused
    //window.addEventListener('keydown', this.handleBackgroundKeyEvents);
  },
  destroyed() {
    //window.removeEventListener('keydown', this.handleBackgroundKeyEvents);
  },
  methods: {
    ...mapMutations('views/context', ['setAnimating', 'setSelectedPageId']),
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    ...mapActions('context', ['addSection'])
  }
};
</script>

<style>
.flip-list-move {
  transition: transform 0.3s, padding-left 0.3s;
}

.list-item-container {
  transition: padding-left 0.3s, transform 0.3s;
}

.flip-list-enter,
.flip-list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.flip-list-leave-active {
  position: absolute !important;
}
</style>
